import { createContext, Component } from 'react'
import i18n from './index'
import { Api, LocalStorage } from '../Services'

const SUPPORTED_LANGUAGES = ['it', 'en', 'fr']
const DEFAULT_LANGUAGE = 'it'
const STORAGE_KEY = 'ems-language'

export const LanguageContext = createContext()

export class LanguageContextProvider extends Component {
  constructor (props) {
    super(props)
    const saved = localStorage.getItem(STORAGE_KEY)
    const language = SUPPORTED_LANGUAGES.includes(saved) ? saved : DEFAULT_LANGUAGE
    this.state = { language }
  }

  // persist=false: applica solo (es. lingua letta dal db al login)
  setLanguage = (lang, persist = true) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return
    localStorage.setItem(STORAGE_KEY, lang)
    i18n.changeLanguage(lang)
    this.setState({ language: lang })
    const userId = LocalStorage.get('_id')
    if (persist && userId) Api.patch(`/users/${userId}`, { lingua: lang })
  }

  render () {
    const { language } = this.state
    return (
      <LanguageContext.Provider value={{
        language,
        setLanguage: this.setLanguage,
        supportedLanguages: SUPPORTED_LANGUAGES
      }}>
        {this.props.children}
      </LanguageContext.Provider>
    )
  }
}

export const withLanguage = (WrappedComponent) => {
  return (props) => (
    <LanguageContext.Consumer>
      {(langContext) => <WrappedComponent {...props} langContext={langContext} />}
    </LanguageContext.Consumer>
  )
}
